import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/authApi';

const savedUser  = () => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } };

export const loginThunk = createAsyncThunk('auth/login', async (dto, { rejectWithValue }) => {
  try { const r = await api.login(dto); return r.data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message || 'Login failed.'); }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: { token: localStorage.getItem('token'), user: savedUser(), loading: false, error: null },
  reducers: {
    logout: state => {
      state.token = null; state.user = null;
      localStorage.removeItem('token'); localStorage.removeItem('user');
    },
    clearError: state => { state.error = null; },
  },
  extraReducers: b => b
    .addCase(loginThunk.pending,   s => { s.loading = true;  s.error = null; })
    .addCase(loginThunk.fulfilled, (s, { payload }) => {
      s.loading = false; s.token = payload.token; s.user = payload;
      localStorage.setItem('token', payload.token);
      localStorage.setItem('user', JSON.stringify(payload));
    })
    .addCase(loginThunk.rejected,  (s, { payload }) => { s.loading = false; s.error = payload; }),
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
